<template>
    <div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">둘러보기관리</h2>
          <article>
            <ul class="search_filter">
              <li>
                <p>파일명</p>
                <input type="text" placeholder="파일명을 입력하세요" class="form_control" v-model="searchInfo.filename">
              </li>
              <li>
                <p>노출여부</p>
                <div class="form_radio">
                  <input type="radio" id="radio1" name="radio" value="" checked v-model="searchInfo.displayYn" > 
                  <label for="radio1">전체</label>
                </div>
                <div class="form_radio">
                  <input type="radio" id="radio2" name="radio" value="Y" v-model="searchInfo.displayYn">
                  <label for="radio2">노출</label>
                </div>
                <div class="form_radio">
                  <input type="radio" id="radio3" name="radio" value="N" v-model="searchInfo.displayYn">
                  <label for="radio3">비노출</label>
                </div>
              </li>
              <li>
                <button class="btn btn_md btn_outline" @click="fn_search">조회</button>
              </li>
            </ul>
          </article>
        </section>
        <section class="view">
          <div class="table_list">
            <div class="table_option">
              <div class="form_select"></div>
              <button class="btn btn_md btn_darkblue" v-b-modal.aroundModal @click="fn_set_aroundInfo('N')">신규 등록</button>
            </div>
            <table class="list no_view">
              <thead>
                <tr>
                    <th>NO</th>
                    <th>이미지</th>
                    <th>파일명</th>
                    <th>설명</th>
                    <th>노출여부</th>
					<th>관리</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="aroundList.length == 0">
                    <td colspan="6"><span>데이터가 없습니다.</span></td>
                </tr>
                <tr v-for="(item, index) in aroundList" v-bind:key="index">
                  <td>
                    <span> {{ index + 1 }} </span>
                  </td>
                  <td>
                    <span class="img_area" v-b-modal.imgModal @click="fn_set_file_url(item.around_file_id)">
                      <!-- <img :src="isImgApi(item.around_file_id)" v-bind:art="item.file_org_name"> -->
                      <img :src="'/file/getImgFile/'+item.around_file_id" v-bind:art="item.file_org_name">
                    </span>
                  </td>
                  <td class="al"><span>{{ item.file_org_name }}</span></td>
                  <td><span>{{ item.around_expl }}</span></td>
                  <td><span>{{ item.display_yn }}</span></td>
                  <td>
                    <div class="form_inline">
                      <button class="icon icon_del" @click="fn_delete(item.around_cd)"></button>
                      <button class="icon icon_edit" v-b-modal.aroundModal @click="fn_set_aroundInfo('M',item)"></button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <Pagination :pageInfo="searchInfo.pageInfo"  v-show="pagingShow"/>
          </div>
        </section>
      </div>
      <imgModal :title="'이미지 보기'" :fileUrl="fileUrl" />
      <AroundModal 
        :id="'around'"
        :item="aroundInfo"
      />   
    </div> 
</template>

<script>
import axios from 'axios'
import Pagination from "@/components/AdminPagination.vue"
import imgModal from "@/modal/admin/imgModal.vue"
import AroundModal from "@/modal/admin/aroundModal.vue"

export default {
    name: 'AroundMngt',
    components: {
      Pagination,
      imgModal,
      AroundModal
    },
    data() {
      return {
        searchInfo : {
            filename : '',
            displayYn : '',
            pageInfo : {
                page : 1,
                pageSize : 10,
                totPage : 0
            }                
        },
        fileUrl : '',
        aroundInfo : {
          around_cd: '',
          around_expl: '',
          around_file_id: '',
          around_file_nm: '',
          display_yn: 'Y',
          status : ''
        },
        pagingShow : false,
        aroundList: [],
        selected: null
      }
    },
    async created(){

        let searchInfoStore = this.$store.getters['commonStore/getSearchInfo'];             
        if(searchInfoStore != null && searchInfoStore != {}){
            this.searchInfo = searchInfoStore
        }
        
        
        this.fn_search();
    },
    methods : {
        fn_search(){

            console.log("@@@ search : ",this.searchInfo);

            this.$store.dispatch('commonStore/setSearchInfo', this.searchInfo); 

            axios
                .post("/api/admin/contents/getAroundList", this.searchInfo)
                .then((res) => {
                    console.log("@@@@ res : %o",res);                    
                    this.aroundList = res.data.arountInfo;
                    

                    console.log("@@@@ aroundList : %o",this.aroundList);

                    this.searchInfo.pageInfo.totPage = res.data.totCnt;
                    
                    if(this.searchInfo.pageInfo.totPage> 0){
                        this.pagingShow = true;                          
                    }                    
                })
                .catch((err) => console.log(err));
        },
        // isImgApi: function (value) {
                
        //         console.log("@@@@@ 111");

        //         axios
        //         .get("/file/getImgFile/"+value)
        //         .then((res) => {
        //             console.log("@@@@ res : %o",res);                    
        //             return res;                  
        //         })
        //         .catch((err) => console.log(err));
                
        // },
        fn_set_file_url(imgUrl){
            this.fileUrl = imgUrl;
        },
        fn_set_aroundInfo(status, item){                        
            if(status == "M"){
              item.status = "M";
              this.aroundInfo = Object.assign({}, item);
              this.aroundInfo.around_file_nm = this.aroundInfo.file_org_name;

            }else{
              this.aroundInfo.status = "N";
              this.aroundInfo.around_cd = '';
              this.aroundInfo.around_expl = '';
              this.aroundInfo.around_file_id = '';
              this.aroundInfo.around_file_nm = '';
              this.aroundInfo.display_yn = 'Y';
            }
        },
        fn_delete(aroundCd){
                
          let param = new Object();
          param.wrapperWrhsCd = wrapperWrhsCd;

          axios
              .post("/api/admin/around/deleteAround", param)
              .then((res) => {
                  alert("삭제되었습니다");
                  this.fn_search();
              })
              .catch((err) => console.log(err));
        }
    }
  }
</script>